import { render, staticRenderFns } from "./FinishedOrders.vue?vue&type=template&id=137fd71d&scoped=true&"
import script from "./FinishedOrders.vue?vue&type=script&lang=js&"
export * from "./FinishedOrders.vue?vue&type=script&lang=js&"
import style0 from "./FinishedOrders.vue?vue&type=style&index=0&id=137fd71d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137fd71d",
  null
  
)

export default component.exports